import Vue from 'vue'
import Card from '../components/Card'
import Child from '../components/Child'
import Button from '../components/Button'
import Link from "@/components/Link.vue";
import Checkbox from '../components/Checkbox'
import UnitAndRoleLink from '~/pages/users/partials/UnitAndRoleLink.vue';
import ScoutingImages from "~/pages/scouting/admin/partials/ScoutingImages.vue";

// Components that are registered globaly.
[
  Card,
  Child,
  Button,
  Link,
  Checkbox,
  UnitAndRoleLink,
  ScoutingImages,
].forEach(Component => {
  Vue.component(Component.name, Component)
})
